export default "__VITE_ASSET__xS54XkUa__"